import React from "react";
import "../../Style/Result.css";

const Result = () => {
  return (
    <>
      <div className="result ">
        <div className="container-xxl p-0">
          <h2 className=" fw-medium">PROVEN RESULTS ACROSS SYDNEY REAL ESTATE</h2>
          <div className="row d-flex align-items-center">
            <div className="col-12">
              <div className="content">
                <p>
                  Experience, consistency, and results matter in Sydney’s competitive real estate market. For award-winning Sydney and NSW real estate professional Di Henneberry, the exceptional outcomes she provides for property owners, purchasers, investors, and landlords define her career.
                </p>
                <p>Di has over 20 years of experience in property management, leasing, business development, and real estate performance. With sharp industry knowledge, deep insight into the Sydney property market, and a client-focused approach, Di has helped position Henneberry Property Group as a trusted choice for people looking to buy or rent Sydney apartments, explore investment properties, and access reliable real estate management services.
</p>
                <p>Her many accolades include:</p>
                <p>Business Development Manager in the McGrath Network from 2014 - 2015</p>
                <p>Female Business Developer of the Year - Finalist (2019) - REB Women in Real Estate Awards</p>
                <p>Business Developer of the Year - Finalist (2019) - REB Awards - Property Management</p>
                <p>Business Developer of the Year (2019) - Ray White Double Bay
</p>
                <p>2019 Allen White Elite Award - Property Management Business Development & Services
</p>
                <p>2021 Highest Rental in Bondi ($6,000 p/w)
</p>
                <p>McGrath Regional Property Management Leader Board</p>
                <p>Presented to new Business Development Managers at McGrath Head Office for Business Growth
</p>
                <p>Novice Auctioneer Competition - Recognised Entrant
</p>
                <p>Strategic marketing, negotiations and property management are key components in Di’s success. With strong negotiations and the ability to clearly communicate to buyers the current market value of a property, Di posted a result of $90,000 over the property reserve in less than 5 weeks of a selling campaign. This result was achieved after taking over the selling campaign from a competing agent in the same market with little success.</p>
                <p>A successful property manager and business developer, Di is uniquely positioned to offer her clients a full suite of services from premium rentals and management, investments and sales across the Sydney property market.
</p>
                

              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Result;
